import {infiniteQueryOptions, keepPreviousData} from '@tanstack/react-query';
import {unwrap} from 'framework';
import type {ListCatalogExercisesInput} from '../application/ports/exercise-catalog.repository';
import type {CatalogExerciseSource} from '../domain/catalog-exercise-source.value-object';
import type {WorkoutsDependencies} from '../dependencies';
import {keys} from './keys';

export type ListCatalogExercisesQueryDependencies = Pick<WorkoutsDependencies, 'controllers'>;

export const listCatalogExercisesQuery = (
  {controllers}: ListCatalogExercisesQueryDependencies,
  source: CatalogExerciseSource,
  query: string,
) =>
  infiniteQueryOptions({
    queryKey: keys.catalogExercises.list(source, query),
    queryFn: ({pageParam}) => {
      const input: ListCatalogExercisesInput = {
        cursor: pageParam,
        source,
        ...(query.length > 0 && {query}),
      };
      return controllers.workoutController.listExercises(input).then(unwrap);
    },
    initialPageParam: null as string | null,
    getNextPageParam: lastPage => lastPage.nextCursor ?? undefined,
    placeholderData: keepPreviousData,
  });
